module.exports = __webpack_public_path__ + "img/mizutamari-cut-05-sp.ef314fbb.jpg";